import { ReactNode } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuthStore, UserRole } from '@/shared/stores/authStore';

interface RoleGuardProps {
    children?: ReactNode;
    allowedRoles: UserRole[];
}

/**
 * RoleGuard Component
 * Protects routes based on user roles and authentication status.
 * Supports both children pattern and React Router 6 Outlet pattern.
 */
export const RoleGuard = ({ children, allowedRoles }: RoleGuardProps) => {
    const { user, isAuthenticated } = useAuthStore();
    const location = useLocation();

    if (!isAuthenticated || !user) {
        // Redirect to login if not authenticated
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    const normalizedUserRole = user.role.toUpperCase();
    if (!allowedRoles.map(r => r.toUpperCase()).includes(normalizedUserRole)) {
        // Redirect to unauthorized if role not allowed
        return <Navigate to="/unauthorized" replace />;
    }

    return children ? <>{children}</> : <Outlet />;
};
